let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lSmtJ")).then(() => parcelRequire('7xXAU'));